<template>
    <section class="home-news-list-sec">
        <div class="container-fluid text-right">
            <div class="home-news-list__nav mr-4">

                <router-link to="/news-cat/1/0" class="home-news-list__nav-link">
                    <span class="text">Све вести</span> <span class="icon-play-circle"></span>
                </router-link>

            </div>
        </div>
        <div class="container-fluid">
            <div class="home-news-list__inner ">
                <div id="news_carousel" class="news_carousel">
                    <slick ref="slick" :options="slickOptions">
                        <!--                        <a href="http://placehold.it/320x120">-->
                        <!--                            <img src="http://placehold.it/320x120" alt="">-->
                        <!--                        </a>-->

                        <!--                        <a href="http://placehold.it/420x220">-->
                        <!--                            <img src="http://placehold.it/420x220" alt="">-->
                        <!--                        </a>-->
                        <!--                        <a href="http://placehold.it/420x220">-->
                        <!--                            <img src="http://placehold.it/420x220" alt="">-->
                        <!--                        </a>-->
                        <!--                        <a href="http://placehold.it/420x220">-->
                        <!--                            <img src="http://placehold.it/420x220" alt="">-->
                        <!--                        </a>-->
                        <div v-for="(news, index) in news_list" v-bind:key="index" class="news-carousel__item">
                            <news-card v-bind:news="news"></news-card>
                        </div>
                    </slick>


                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import Slick from 'vue-slick';
import NewsCard from '@/components/NewsCard.vue'


export default {
    name: "HomeNewsListSec",
    data() {
        return {
            news_list: [],
            baseApiUrl: window.env.VUE_APP_API_DI_DEV,
            slickOptions: {
                slidesToShow: 6,
                slidesToScroll: 3,
                dots: true,
                infinite: false,
                // Any other options that can be got from plugin documentation

                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 2,
                            infinite: true,
                            dots: true
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            infinite: true,
                            dots: true
                        }
                    },
                    {

                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            dots: false,
                        }
                    },
                    {

                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            dots: false,
                        }
                    }
                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                ]
            },
        }
    },
    components: {
        NewsCard,
        Slick
    },
    methods: {
        next() {
            this.$refs.slick.next()
        },
        prev() {
            this.$refs.slick.prev()
        },
        reInit() {
            // Helpful if you have to deal with v-for to update dynamic lists
            this.$refs.slick.reSlick()
        },
        fetchData() {
            axios.get(this.baseApiUrl + 'FP/SearchByCategory?category=1&page=0&take=10').then(response => {
                // console.log("base_list : ", response);
                this.news_list = response.data
            })

        },
    },
    mounted() {
        this.fetchData();
    },
    beforeUpdate() {
        if (this.$refs.slick) {
            this.$refs.slick.destroy();
        }
    },
    updated() {
        this.$nextTick(function () {
            if (this.$refs.slick) {
                this.$refs.slick.create(this.slickOptions);
            }
        });
    },
}
</script>
